import { Component } from '@angular/core';
import { AppPermission } from '@app/shared/services/apps/apps.service';

@Component({
  selector: 'sbnb-tidy',
  templateUrl: './tidy.component.html',
})
export class TidyComponent {
  AppPermission = AppPermission;
} 